import _createForOfIteratorHelper from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/igorserzhan/projects/manual-pro/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontcommand
 */
import Command from '@ckeditor/ckeditor5-core/src/command';
/**
 * The base font command.
 *
 * @extends module:core/command~Command
 */

var FontCommand = /*#__PURE__*/function (_Command) {
  _inherits(FontCommand, _Command);

  var _super = _createSuper(FontCommand);

  /**
   * Creates an instance of the command.
   *
   * @param {module:core/editor/editor~Editor} editor Editor instance.
   * @param {String} attributeKey The name of a model attribute on which this command operates.
   */
  function FontCommand(editor, attributeKey) {
    var _this;

    _classCallCheck(this, FontCommand);

    _this = _super.call(this, editor);
    /**
     * When set, it reflects the {@link #attributeKey} value of the selection.
     *
     * @observable
     * @readonly
     * @member {String} module:font/fontcommand~FontCommand#value
     */

    /**
     * A model attribute on which this command operates.
     *
     * @readonly
     * @member {Boolean} module:font/fontcommand~FontCommand#attributeKey
     */

    _this.attributeKey = attributeKey;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FontCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.value = doc.selection.getAttribute(this.attributeKey);
      this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, this.attributeKey);
    }
    /**
     * Executes the command. Applies the `value` of the {@link #attributeKey} to the selection.
     * If no `value` is passed, it removes the attribute from the selection.
     *
     * @protected
     * @param {Object} [options] Options for the executed command.
     * @param {String} [options.value] The value to apply.
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      var selection = document.selection;
      var value = options.value;
      model.change(function (writer) {
        if (selection.isCollapsed) {
          if (value) {
            writer.setSelectionAttribute(_this2.attributeKey, value);
          } else {
            writer.removeSelectionAttribute(_this2.attributeKey);
          }
        } else {
          var ranges = model.schema.getValidRanges(selection.getRanges(), _this2.attributeKey);

          var _iterator = _createForOfIteratorHelper(ranges),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var range = _step.value;

              if (value) {
                writer.setAttribute(_this2.attributeKey, value, range);
              } else {
                writer.removeAttribute(_this2.attributeKey, range);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
    }
  }]);

  return FontCommand;
}(Command);

export { FontCommand as default };